import {camelToDashes} from 'rlink-utils/string';
import {StructuredDataContent} from 'rlink-repos/content';

export class Denormalizer extends StructuredDataContent {
  static contentData (content) {
    if (content.registeredName === this.mainContentClass) {
      return content.data;
    } else {
      return content.data.set('$path', content.path);
    }

  }
  static shouldDenormalize(mainContent) {
    return true;
  }

  static async index (command, repo) {

    if (command.constructor.isContentCommand) {
      // index change in main content
      if (command.contentClassName === this.mainContentClass) {
        let mainContent = await repo.fetchContentAtPath(command.contentPath);

        let denormalized;
        if (mainContent) {
          if (!this.shouldDenormalize(mainContent)) {
            return [];
          }
          denormalized = await this.getForMainContent(mainContent, repo);
        }

        if (command.name === 'DeleteContent') {
          if (denormalized) {
            return [denormalized.deleteCommand()];
          } else {
            // there is just no way to locate the generated
            // denormalized file if it depends on a content property
            // from content that is now deleted
            //
            // However, since no view will attempt to load the
            // generated content, we can simply ignore it and do nothing.
            return [];
          }


        } else {
          // update main data keys only:
          let newMainData = this.contentData(mainContent);
          for ( let [key, value] of newMainData.entries() ) {
            denormalized = denormalized.change(key, value);
          }

          // then update all the map keys
          for (let [fromKey, toKey] of Object.values(this.mapping)) {
            let mappedContent = await repo.fetchContentAtPath(
              mainContent[fromKey]);
            if (mappedContent) {
              denormalized = denormalized.change(toKey,
                this.contentData(mappedContent));
            }

          }
          return [denormalized];
        }
      }
      // index change in mapped content
      if (command.contentClassName in this.mapping) {
        let [fromKey, toKey] = this.mapping[command.contentClassName];
        let mappedContent = await repo.fetchContentAtPath(
          command.contentPath);
        let changedContent = [];
        //  must find all instances of this and check
        for (let promise of await repo.eachContent(this.pathPrefix)) {
          let denormalized = await promise;
          let mappedPath = denormalized.data.getIn([toKey, '$path']);
          if (!mappedPath && denormalized.data.has(toKey)) {
            throw new Error(`Mapped content of ${denormalized} at key '${toKey}' is missing a $path! Ensure the $path key is retained in contentData()!`);
          }
          if (command.contentPath === mappedPath) {
            if (command.name === 'DeleteContent') {
              changedContent.push(denormalized.removeValue(toKey));
            } else {
              changedContent.push(denormalized.change(toKey, this.contentData(mappedContent)));
            }
          }
        }
        return changedContent;
      }
      return [];
    } else {
      throw new Error("Don't know how to denormalize non-ContentCommands");
    }
  }


  static get (repo, pathKey) {
    return repo.fetchContentAtPath(this.pathForPathKey(pathKey), this);
  }

  static get pathPrefix () {
    return `/generated/${camelToDashes(this.mainContentClass)}/`
  }

  static pathForPathKey (pathKey) {
    return this.pathPrefix + pathKey + '.json';
  }

  static pathForMainContent (content) {
    return this.pathForPathKey(content[this.pathKey]);
  }
  static getForMainContent (content, repo) {
    // ugh - why is this needed?
    let registry = repo.contentRegistry;
    if (registry.hasClassNamed(this.name)) {
      let existing = registry.loadClassNamed(this.name);
      if (existing.indexFileName !== this.indexFileName) {
        throw new Error(`Can't register indexer ${this.name} because it is already registered by ${existing}`);
      }
    }
    repo.contentRegistry.registerClass(this.name, this, true);

    return this.fetchOrMakeFromPath(repo,
      this.pathForMainContent(content),
      this.contentData(content).toJS()
    );
  }

}



// WEBPACK FOOTER //
// ./lib/rlink-cms/indexing/denormalizer.js